import React from 'react';
import AstrologyChatbot from './components/AstrologyChatbot';
import './App.css';

function App() {
  return (
    <div className="App">
      <AstrologyChatbot />
    </div>
  );
}

export default App;
